import { RouteDefinition }  from '@core/interfaces/route.interface';
import { adapterSelectors } from '@core/store/adapter/adapter.selectors';
import { RouterState }      from '@core/store/router/router.state';
import { EntityAdapter }    from '@ngrx/entity';
import {
	createFeatureSelector,
	createSelector
}                           from '@ngrx/store';
import { LoggerService }    from '@shared/services/logger.service';


export function routerSelector(
	adapter: EntityAdapter<RouteDefinition>,
	storeId: string,
	logger: LoggerService
) {
	const routerStateSelector = createFeatureSelector<RouterState>( storeId );
	const adapterSelector = { ...adapterSelectors<RouteDefinition, RouterState>( adapter, routerStateSelector ) };


	const selectActiveRoute = createSelector(
		adapterSelector.all,
		( routeDefinitionList: RouteDefinition[] ) =>
			routeDefinitionList.find( ( routeDefinition: RouteDefinition ) => routeDefinition.isActiveRoute )
	);

	const selectPreviousRoute = createSelector(
		adapterSelector.all,
		( routeDefinitionList: RouteDefinition[] ) => {
			return routeDefinitionList?.length > 1
						 ? routeDefinitionList[ routeDefinitionList?.length - 2 ]
						 : null;
		}
	);

	const selectRouteById = ( routeId: string ) =>
		createSelector(
			adapterSelector.all,
			( routeDefinitionList: RouteDefinition[] ) =>
				routeDefinitionList?.find( ( routeDefinition: RouteDefinition ) => routeDefinition?.id === routeId )
		);

	return {
		adapterSelector,
		selectActiveRoute,
		selectPreviousRoute,
		selectRouteById
	};
}

